VLW.scrollBar = class extends VLW.classBase {
	constructor(el, ctrl, horizontal) {
		super();
		this.elt                      = el;
		this.scrollId 				  = this.elt.getAttribute("scrollid");
		var state = {
			scrollTop: this.elt.getAttribute("historyScrollTop") || this.elt.scrollTop,
			scrollLeft: this.elt.getAttribute("historyScrollLeft") || this.elt.scrollLeft
		};
		this.ctrl                     = ctrl;
		this.horizontal               = (horizontal || false);
		this.elt.vlwScrollBarInstance = this;
		this.elt.classList.add("initializing");
		this.direction            = {};
		this.direction.typeScroll = (this.horizontal === true) ? "x" : "y";
		this.direction.scroll     = (this.horizontal === true) ? "scrollWidth" : "scrollHeight";
		this.direction.scroll2    = (this.horizontal === true) ? "scrollTop" : "scrollLeft";
		this.direction.offset     = (this.horizontal === true) ? "offsetWidth" : "offsetHeight";
		this.direction.max        = (this.horizontal === true) ? "maxX" : "maxY";
		this.direction.client     = (this.horizontal === true) ? "clientWidth" : "clientHeight";
		var newdiv1               = document.createElement("div");
		var newdiv2               = document.createElement("div");
		var newdiv4               = document.createElement("div");
		var newdiv3               = document.createElement("div");
		newdiv1.classList.add("vlwScrollMask");
		newdiv2.classList.add("vlwScrollContent");
		if(this.scrollId){
			this.elt.setAttribute("scrollid", "");
			newdiv2.setAttribute("scrollid", this.scrollId);
		}
		newdiv3.classList.add("vlwScrollContent__Align");
		newdiv4.classList.add("vlwScrollBar");
		while (this.elt.children.length > 0) {
			newdiv3.appendChild(this.elt.children[0]);
		}
		if(window.getComputedStyle(this.elt)["max-height"]!="none") {
			newdiv2.style.maxHeight = window.getComputedStyle(this.elt)["max-height"];
		}
		newdiv2.appendChild(newdiv3);
		newdiv1.style.left         = "-"+(CONFIG.scrollbarWidth+1 ) + "px";
		newdiv2.style.left         = (CONFIG.scrollbarWidth +1) + "px";
		newdiv2.style.paddingRight = "3px";
		newdiv1.appendChild(newdiv2);
		newdiv4.innerHTML  = "<div class='vlwScrollBar_bar'></div><div class='vlwScrollBar_cursor'  ><div class='vlwScrollBar_cursor_inner'></div></div>";
		this.elt.innerHTML = "";
		this.elt.appendChild(newdiv1);
		this.elt.appendChild(newdiv4);
		newdiv2.scrollTop = state.scrollTop;
		newdiv2.scrollLeft = state.scrollLeft;
		this.scrollBar      = this.elt.querySelector(".vlwScrollBar");
		this.scrollCur      = this.elt.querySelector(".vlwScrollBar_cursor");
		this.scrollCurInner = this.elt.querySelector(".vlwScrollBar_cursor_inner");
		this.scrollCon      = this.elt.querySelector(".vlwScrollContent");
		this.scrollMas      = this.elt.querySelector(".vlwScrollMask");
		/**** AJOUT Pour longueur de la barre de scroll ****/
		this.scrollCon.addEventListener("scroll", this.onScrollText, supportsPassive);
		this.scrollCon.addEventListener("touchstart", this.stopPropagation, supportsPassive);
		this.scrollCon.addEventListener("touchmove", this.stopPropagation, supportsPassive);
		this.scrollCon.addEventListener(EVENTS.MOUSEWHEEL, this.stopPropagation, supportsPassive);
		this.myDrag = Draggable.create(this.scrollCur, {type: this.direction.typeScroll, bounds: this.scrollBar, onDrag: this.onDrag, onDragEnd: this.onDragEnd, onDragStart: this.onDragStart})[0];
		TweenMax.delayedCall(.1, this.update);
		window.addEventListener("resize", this.update);
		//this.scrollCurInner.style.height = "50px";
		//	this.update();
	}

	reset() {
		this.update();
		TweenMax.to(this.scrollCon, 0, {scrollTo: {y: 0, autoKill: false}});
	}

	update(e) {
		if(window.getComputedStyle(this.elt)["max-height"]!="none") {
			this.elt.querySelector(".vlwScrollContent").style.maxHeight = window.getComputedStyle(this.elt)["max-height"];
		}
		if (this.scrollCon[this.direction.scroll] <= this.scrollCon[this.direction.offset]) {
			this.scrollBar.style.display = "none";
			this.elt.classList.add("noscroll");
		} else {
			var pecentBarre = (this.scrollCon[this.direction.client] / this.scrollCon[this.direction.scroll] * 100);
			if (pecentBarre < 20) {
				pecentBarre = 20;
			}
			this.scrollCur.style.height      = pecentBarre + "%";
			this.scrollCurInner.style.height = "100%;";
			this.scrollBar.style.display     = "block";
			this.elt.classList.remove("noscroll");
		}
		this.elt.classList.remove("initializing");
	}

	stopPropagation(e) {
		var _percent = ((e.currentTarget.scrollTop / (e.currentTarget[this.direction.scroll] - e.currentTarget[this.direction.offset])).toFixed(2));
		e.stopPropagation();
		return false;
	}

	onScrollText(e) {
		e.stopPropagation();
		var _percent = ((e.currentTarget.scrollTop / (e.currentTarget[this.direction.scroll] - e.currentTarget[this.direction.offset])).toFixed(2));

		/*TweenMax.to(this.scrollCur, .25, {y: (_percent *    this.myDrag[this.direction.max])});*/
		TweenMax.to(this.scrollCur, .25, {y: (_percent * (this.scrollBar.offsetHeight - this.scrollCur.offsetHeight))});
		this.myDrag.update();
	}

	onDragStart(e) {
		this.scrollCon.removeEventListener("scroll", this.onScrollText);
	}

	onDragEnd(e) {
		this.scrollCon.addEventListener("scroll", this.onScrollText);
	}

	onDrag(e) {
		var _percent = this.myDrag.y / this.myDrag[this.direction.max];
		var _yTo     = _percent * (this.scrollCon[this.direction.scroll] - this.scrollCon[this.direction.client]);
		TweenMax.to(this.scrollCon, .25, {scrollTo: {y: _yTo, autoKill: false}});
	}

	instanceClean() {
		this.elt.vlwScrollBarInstance = null;
		this.myDrag.kill();
		window.removeEventListener("resize", this.update);
		this.scrollCon.removeEventListener("scroll", this.onScrollText);
		this.scrollCon.removeEventListener("touchstart", this.stopPropagation);
		this.scrollCon.removeEventListener("touchmove", this.stopPropagation);
		this.scrollCon.removeEventListener(EVENTS.MOUSEWHEEL, this.stopPropagation);
		VLW.classBase.prototype.instanceClean.call(this);

	}

};
